import { MetadataRow } from "../../global";
import { GenericMetaNode } from "./GenericMetaNode";
import { PNodeListMeta } from "../properties/PNodeListMeta";

export class AbstractMetaJsonNode extends GenericMetaNode {
  id: number;
  name: string;

  createProperties() {
    return [];
  }

  toMetadataRow(): MetadataRow {
    return {
      id: this["id"],
      name: this["name"],
      Json: this.toJSON((p) => p.type && !(p instanceof PNodeListMeta)),
    } as MetadataRow;
  }

  fromMetadataRow(row: MetadataRow) {
    this.fromJSON(row["Json"], (p) => p.type && !(p instanceof PNodeListMeta));
    ["id", "name"].forEach((key) => this.findProperty(key).set(row[key]));
    return this;
  }
}
